/**
 * Block-for-block skeleton for the /tasks page.
 *
 * Mirrors the live layout: page header, filter chip strip placeholder,
 * a table of six placeholder rows. Per the CLAUDE.md "Loading states"
 * guidance, never render a plain `Loading...` string here.
 */

import { Skeleton } from '@ordo/ui/skeleton'

export function TasksSkeleton() {
  return (
    <div
      className="mx-auto flex w-full max-w-[100rem] flex-col gap-6 p-4 lg:pt-5"
      aria-busy="true"
      aria-label="Loading tasks">
      <header className="flex items-center justify-between border-b border-border pb-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-8 w-32" />
        </div>
        <div className="hidden gap-2 md:flex">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-20" />
        </div>
      </header>

      <div className="flex flex-wrap gap-1.5">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-7 w-24 rounded-full" />
        ))}
      </div>

      <div className="flex flex-col gap-1">
        {Array.from({ length: 6 }).map((_, i) => (
          <RowSkeleton key={i} />
        ))}
      </div>
    </div>
  )
}

function RowSkeleton() {
  return (
    <div className="flex items-start justify-between gap-4 rounded-md px-3 py-2.5">
      <div className="flex min-w-0 items-start gap-3">
        <Skeleton className="mt-1.5 h-2 w-2 rounded-full" />
        <div className="min-w-0 flex-1 space-y-1.5">
          <Skeleton className="h-4 w-64" />
          <Skeleton className="h-3 w-40" />
        </div>
      </div>
      <Skeleton className="h-3 w-16" />
    </div>
  )
}
